import { apiFetch } from './client';

export const getAssets   = (systemId, params = {}) => apiFetch(`/assets/?${new URLSearchParams({ system_id: systemId, ...params })}`);
export const getAsset    = (id, systemId)           => apiFetch(`/assets/${id}?system_id=${systemId}`);
export const createAsset = (systemId, data)         => apiFetch(`/assets/?system_id=${systemId}`, { method: 'POST', body: JSON.stringify(data) });
export const updateAsset = (id, systemId, data)     => apiFetch(`/assets/${id}?system_id=${systemId}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteAsset = (id, systemId)           => apiFetch(`/assets/${id}?system_id=${systemId}`, { method: 'DELETE' });
